import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private gtmId = environment.gtmid;

  constructor() { }

  injectGtmScripts() {
    this.addGoogleTagManager();

    if (environment.production == true) {
      this.addGtmScript(); //script para métricas do GTM
      this.addClarityScript();
    }
  }

  private addGoogleTagManager() {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${this.gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }

  private addClarityScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "q1n736eupb");
    `;
    document.head.appendChild(script);
  }

  pushEvent(eventName: string, params: Record<string, any> = {}) {
    const dataLayer = (window as any)['dataLayer'] = (window as any)['dataLayer'] || [];
    dataLayer.push({ event: eventName, ...params });
  }

  private addGtmScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${this.gtmId}');`
  }
}
